import { configureStore } from '@reduxjs/toolkit';
import { formCounterSlice } from './formCounter';
import { assessmentSlice } from './assessment';
import { visaPageManageSlice } from './visaPageManagement';
import EmployeeListSlice from './usersPermissions';
import authSlice from './auth/auth-slice';
import userSlice from './user/user-slice';
import alert from './alert';

import applicationSlice from './application/application.slice';
import applicationsSlice from './applications/applications-slice';
import milestonesSlice from './application/milestones/milestones.slice';
import documentsSlice from './application/documents/documents-slice';
import documentSlice from './application/document/document.slice';
import docCommentsSlice from './application/doc-comments/doc-comments.slice';
import retainerAgreementSlice from './retainer-agreement/agreement.slice';
import assessmentAgreementSlice from './assessment-agreement/assessment_agreement.slice';
import myClientsSlice from './my-clients/my-clients.slice';
import salesClientsSlice from './sales-clients/sales-clients.slice';
import paymentSlice from './payment/payment.slice';
import serviceProviderSlice from './service-provider/service-provider.slice';
import serviceProvidersSlice from './service-providers/service-providers.slice';
import immigrationProfessionalSlice from './immigration-professional/immigration-professional.slice';

import expertiseListSlice from './expertise-list/expertise-list.slice';

import snakeBarSlice from './snake-bar.slice';
import { ctaButtonSlice } from './calculatedData/ctaButton';

import adminUsersSlice from './admin-users/admin-users.slice';
import permissionsSlice from './permissions/permissions.slice';
import templatesSlice from './retainer-templates/templates.slice';
import signaturesSlice from './signatures/signatures.slice';
import programsSlice from './programs/programs.slice';
import agentsSlice from './agents/agents.slice';
import myaliroBillingSlice from './myaliro-billing/myaliro-billing.slice';
import tickets from 'redux/v2/tickets';
import selectedAccount from 'redux/selected-account/selected-account.slice';
import selectedApplication from 'redux/v2/selectedApplication.reducer';

export const store = configureStore({
    reducer: {
        formCounter: formCounterSlice.reducer,
        assessment: assessmentSlice.reducer,
        visaPageManage: visaPageManageSlice.reducer,
        employees: EmployeeListSlice,
        auth: authSlice,
        user: userSlice,

        application: applicationSlice,
        applications: applicationsSlice,
        milestonesApp: milestonesSlice,
        documentsApp: documentsSlice,
        documentApp: documentSlice,
        docComments: docCommentsSlice,
        retainerAgreement: retainerAgreementSlice,
        assessmentAgreement: assessmentAgreementSlice,
        myClients: myClientsSlice,
        salesClients: salesClientsSlice,

        payment: paymentSlice,
        serviceProvider: serviceProviderSlice,
        serviceProviders: serviceProvidersSlice,
        immigrationProfessional: immigrationProfessionalSlice,
        snakeBar: snakeBarSlice,

        expertiseList: expertiseListSlice,
        ctaButton: ctaButtonSlice.reducer,

        adminUsers: adminUsersSlice,
        permissions: permissionsSlice,
        templates: templatesSlice,
        signatures: signaturesSlice,
        programs: programsSlice,
        agents: agentsSlice,
        alert,
        myaliroBilling: myaliroBillingSlice,
        tickets,
        selectedAccount,
        selectedApplication,
    },
    devTools: true,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
